import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { CalendarAppBaseText, defaultBaseText } from './text-interface';

declare const lastDate: string;
declare const pageData: CalendarAppBaseText;

let productionSeasonId: string = (window as any).productionSeasonId || "";
let layoutBreakpoint: string = (window as any).layoutBreakpoint || "1024px";
let promoCode: string = "";
let showShareButtons: boolean = (window as any).showShareButtons == true;

let promoCodeData: any = (window as any).promoCode || null;
let promoCodeDescription = "";
if (promoCodeData?.hasOwnProperty("promoCode")) {
    // Full promo code data
    if (promoCodeData.promoCode?.hasOwnProperty("source")) {
        promoCode = promoCodeData.promoCode.source.id;
        promoCodeDescription = promoCodeData.promoCode.promoCode;
    }
    // Just source ID # provided or null
    else {
        promoCode = promoCodeData.promoCode;
    }
}

let orderOfVenueForEventsData = JSON.parse((window as any).orderOfVenueForEvents) || "";

export interface CalendarBaseSettings extends CalendarAppBaseText {
    lastDate: string,
    promoCode: string,
    promoCodeDescription: string,
    productionSeasonId: string,
    layoutBreakpoint: string,
    showShareButtons: boolean,
    orderOfVenueForEvents: string[]
}

const initialState = {
    ...defaultBaseText,
    lastDate: lastDate || "",
    promoCode: promoCode || "",
    promoCodeDescription: promoCodeDescription,
    productionSeasonId: productionSeasonId,
    layoutBreakpoint: layoutBreakpoint,
    showShareButtons: showShareButtons,
    orderOfVenueForEvents: orderOfVenueForEventsData.orderOfVenueForEvents
}

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        initializeSettings(state) {
            return {
                ...initialState, ...pageData
            };
        },
        setAppliedPromo(state, action: PayloadAction<string>) {
            state.promoCode = action.payload;
            // This description is only populated on load. If a promo is applied, the description will be returned via the API
            state.promoCodeDescription = "";
        }
    }
});

export const { initializeSettings, setAppliedPromo } = settingsSlice.actions;
export default settingsSlice.reducer;